import type { DragnetBrowser } from './dragnet-browser';
import type { Logger } from '@zg-rentals/logger-browser';
import { DragnetJsExceptionCategory } from '@zg-rentals/ts-dragnet-client/types/dragnet/DragnetJsExceptionCategory';
import type { JsHttpRequestRecordDto } from '@zg-rentals/ts-dragnet-client/types/dragnet/JsHttpRequestRecordDto';
import { defineReporter, type LogHttpRequest } from '@zg-rentals/monitor-base';
import { generateDragnetHttpRequest } from '@zg-rentals/dragnet-base';
import { task } from 'true-myth';

function generateHttpRequestFromWindow(context?: Record<string, unknown>): LogHttpRequest {
  const fullContext = context ?? {};
  if (fullContext.userAgent) {
    fullContext.ua = fullContext.userAgent;
    delete fullContext.userAgent;
  }

  return {
    url: window.location.href,
    method: 'GET',
    params: Object.fromEntries(new URLSearchParams(window.location.search)),
    body: JSON.stringify(fullContext),
  };
}

export function dragnetReporter(dragnet: DragnetBrowser, logger?: Logger) {
  return defineReporter({
    error: (err: {
      error: Error;
      httpRequest?: LogHttpRequest;
      isErrorBoundary?: boolean;
      errorType?: string;
      context?: Record<string, unknown>;
    }) =>
      task.tryOrElse(
        (reason) => `dragnetReport error: ${reason}`,
        async () => {
          const errHttpRequest = err.httpRequest;

          let httpRequest: JsHttpRequestRecordDto | undefined = undefined;

          try {
            httpRequest = generateDragnetHttpRequest(
              errHttpRequest ?? generateHttpRequestFromWindow(err.context ?? {}),
            );
          } catch (e) {
            logger?.error('Error while generating dragnet request ' + e.stack);
          }

          await dragnet.reportError({
            httpRequest,
            error: err.error,
            category:
              err.errorType === 'HTTPError'
                ? DragnetJsExceptionCategory.BROWSER_HTTP_ERROR
                : err.isErrorBoundary
                  ? DragnetJsExceptionCategory.BOUNDARY_BROWSER_ERROR
                  : DragnetJsExceptionCategory.BROWSER_ERROR,
          });
        },
      ),
  });
}
